import { render, staticRenderFns } from "./global-loader.vue?vue&type=template&id=65550e23&scoped=true"
import script from "./global-loader.vue?vue&type=script&lang=ts"
export * from "./global-loader.vue?vue&type=script&lang=ts"
import style0 from "./global-loader.vue?vue&type=style&index=0&id=65550e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65550e23",
  null
  
)

export default component.exports